export const today = new Date();

export const minAge = new Date(
  today.getFullYear() - 18,
  today.getMonth(),
  today.getDate(),
);

export const parseDDMMYYYY = (value: string) => {
  const [day, month, year] = value.split('/').map(Number);
  return {
    date: new Date(year, month - 1, day),
    day,
    month,
    year,
  };
};

export const isValidDate = (value?: string) => {
  if (!value) return false;
  const { date, day, month, year } = parseDDMMYYYY(value);
  return (
    date &&
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};

export const isOver18 = (value?: string) => {
  if (!isValidDate(value)) return false;
  const { date } = parseDDMMYYYY(value!);
  return date <= minAge;
};

export const isNotTodayOrFuture = (value?: string) => {
  if (!isValidDate(value)) return false;
  const { date } = parseDDMMYYYY(value!);
  return date < today;
};

export const toIsoDate = (value: string): string => {
  const [day, month, year] = value.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
